import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import get from 'lodash.get';
import { MuiBox, FlexBox, Typography } from '@kis-technologies/kis-ui';
import { ReactComponent as CartIcon } from 'assets/cart_icon.svg';
import { CartSummaryOverlay } from 'components/CartSummary';
import { selectors as cartSelector, Cart } from 'services/cart';
import { Configuration, selectors as configSelectors } from 'services/configuration';
import { selectors as ticketingSelectors } from 'services/ticketing';
import { CartItemCount, useStyles } from '../styled';

/**
 * Button that shows the number of items in the cart,
 * and displays the CartSummaryOverlay when tapped.
 */
export const CartSummaryButton = () => {
  const { t, i18n } = useTranslation();

  const cart = useSelector(cartSelector.selectCart) as Cart;
  const configuration = useSelector(configSelectors.selectConfiguration) as Configuration;
  const ticketingPath = useSelector(ticketingSelectors.selectTicketingConfigPath);

  const [showCartSummaryOverlay, setShowCartSummaryOverlay] = useState(false);

  const palette = get(configuration, 'configuration.globalSettings.palette');
  const summaryButton = get(
    configuration,
    `${ticketingPath}.cart.summary.messages.buttons.${i18n.language}[0]`,
    t('cartSummary.orderSummary')
  );

  const classes = useStyles();

  return (
    <>
      {/* Only show the cart summary button when the cart has items */}
      {cart && cart.quantity && cart.quantity > 0 ? (
        <FlexBox
          direction="row"
          data-testid="cart-summary-button"
          align="center"
          onClick={() => setShowCartSummaryOverlay(true)}
          padding="1 6"
          sx={{
            background: palette?.primary,
            borderRadius: '50px',
            transition: '0.2s cubic-bezier(0.4,0,0.2,1) all',
            boxShadow: '0 3px 9px 0 rgba(0,0,0,0.25)',
            cursor: 'pointer'
          }}
        >
          <Typography className={classes.buttonText} data-testid="cart-summary-button-text">
            {summaryButton}
          </Typography>
          <MuiBox className={classes.cartIconBox}>
            <CartIcon />
          </MuiBox>
          <CartItemCount>{cart.quantity}</CartItemCount>
        </FlexBox>
      ) : null}

      {/* Only show the cart summary overlay after the button is tapped */}
      {showCartSummaryOverlay && <CartSummaryOverlay setShowCartSummaryOverlay={setShowCartSummaryOverlay} />}
    </>
  );
};
